import React from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';

import FormattedLink from '@stubhub/react-formatted-link';

import '../styles/index.scss';

class UKRedirectModal extends React.Component {
  componentDidMount() {
    /* istanbul ignore next */
    setTimeout(() => {
      if (window) {
        window.location.href = 'https://www.stubhub.co.uk';
      }
    }, 3000);
  }

  onContinue = () => {
    /* istanbul ignore next */
    if (window) {
      window.location.href = 'https://www.stubhub.co.uk';
    }
  };

  render() {
    return (
      <div className="UKRedirectModal__Container">
        <div className="UKRedirectModal__Content">
          <span className="UKRedirectModal__Image" />
          <h3 className="UKRedirectModal__Title">
            <FormattedMessage
              id="UKRedirectModal.title"
              defaultMessage="Redirecting you to StubHub International, this should only take a moment."
            />
          </h3>
          <FormattedLink className="UKRedirectModal__Cta" onClick={this.onContinue}>
            <FormattedMessage id="UKRedirectModal.cta" defaultMessage="Take me there" />
          </FormattedLink>
        </div>
      </div>
    );
  }
}

export default injectIntl(UKRedirectModal);
